<template>
  <div>
    <div class="alert alert-info">{{ ta('select_tenant') }}</div>
    <ul>
      <li
        v-for="tenant in props.tenants"
        :key="tenant.id"
        class="tenant"
        @click="emit('selectTenant', tenant.id)"
      >
        {{ tenant.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { adminI18n } from '@/i18n';

function ta(key) {
  return adminI18n.t(key);
}

const props = defineProps(['tenants']);
const emit = defineEmits(['selectTenant']);
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tenant {
  display: block;
  padding: 0.5rem;
  font-size: 1.2rem;
  cursor: pointer;

  &:hover {
    background-color: $color-snow;
  }
}

.tenant + .tenant {
  border-top: 1px solid $color-cloud;
}
</style>
